import Image from "antd/es/image";
import React from "react";
import {useTranslation} from "react-i18next";

export default (prop) => {

    return <div style={prop.style} className={'captain'}>Captain</div>

}
